import React, { useState, useEffect, useContext } from 'react'
import { navigate } from 'gatsby'

import iconTopLogaout from '../../../assets/images/iconTopLogaout.png'
import Button from '../../atoms/button/button'

import iconTop from '../../../assets/images/iconTop.png'

import userSessionStorage from '../../../utils/userSessionStorage'
import gameServices from '../../../services/game-service'
import {
  dateEndGame,
  gameId,
  topNumber,
} from '../../../constants/activity-constants'

import { siteUrl } from '../../../shared/utils/siteUrl'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'

import { Context } from '../../../context/app-context'

import './topSection.scss'
import getUrlIdRegister from '../../../utils/getUrlIdRegister'

const TopSection = ({ isMobile }) => {
  const session = new userSessionStorage()

  const [topWinners, setTopWinners] = useState([])
  const [userData, setUserData] = useState({})

  const { dispatch } = useContext(Context)

  useEffect(() => {
    getTop()
  }, [])

  const getTop = () => {
    let tokenId = session.getToken()?.idToken
    const config = {
      headers: tokenId
        ? {
            Authorization: tokenId,
          }
        : undefined,
    }
    gameServices.getTopPagination(gameId, 10, 0, config).then(res => {
      if (res.status === 200) {
        setUserData(res.data)
        setTopWinners(res.data.topGame)
      }
    })
  }

  const formatNumber = number => {
    if (number) return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return
  }

  return (
    <div className="f-topSection-container">
      <div id="top-jugadoras" className="f-topSection-container__ancla" />
      <section className="f-topSection-container__left">
        <h2>Las mejores jugadoras están acá:</h2>
        <div className="f-topSection-container__left__list">
          {!isMobile && (
            <div className="f-topSection-container__left__list__headerList">
              <h3>Nombre</h3>
              <h3>Correo</h3>
            </div>
          )}
          <ol>
            {topWinners.map((item, index) => {
              return (
                <li key={'top' + index}>
                  <img src={iconTop} alt="" />
                  <p>
                    <b>{index + 1}.</b>
                    {item.name}
                  </p>
                  <p>{item.email}</p>
                </li>
              )
            })}
          </ol>
        </div>
      </section>
      <section className="f-topSection-container__right">
        {session.getUserInfo() ? (
          <>
            <h3>¡Hola {session.getUserInfo().name.split(' ')[0]}!</h3>
            <div className="f-topSection-container__right__scores">
              <div className="f-pointsAndPosition">
                <p className="f-pointsAndPosition__textInfo">
                  Tus Puntos <br />
                  <span>
                    {userData.point ? formatNumber(userData.point) : 0}
                  </span>
                </p>
              </div>
              <div className="f-pointsAndPosition">
                <p className="f-pointsAndPosition__textInfo">
                  Tu Puesto <br />
                  <span>{userData.position}</span>
                </p>
              </div>
            </div>
            <p>
              Si no estás en <span> nuestro top {topNumber}</span> ¡seguí
              jugando y no te rindás! tenés <span>hasta el {dateEndGame} </span>
              para alcanzar los mejores puntajes.
            </p>
            <h3>¡Participá y divertite!</h3>
            <Button
              title="¡Jugar!"
              size="f-small"
              color="f-blue"
              props="mt-30"
              onClick={() => {
                pushEventDataLayer(
                  'Interacciones - Participa y diviertete',
                  'cur-v-shooter',
                  'click juego',
                  'jugar'
                )
                navigate('/jugar')
              }}
            />
          </>
        ) : (
          <>
            <h2>TOP JUGADORAS</h2>
            <img src={iconTopLogaout} alt="gotas de flujo" />
            <p>
              {' '}
              <span> Iniciá sesión</span> para conocer tu puntaje y tu posición
              dentro del top de jugadoras.
              <br /> <br />
              Si aún no formás parte de NosotrasOnline <span>
                registrate
              </span>{' '}
              <a
                onClick={() => {
                  window.open(
                    siteUrl + getUrlIdRegister(),
                    '_blank'
                  )
                }}
              >
                acá
              </a>
            </p>
            <Button
              title="Iniciá sesión"
              size="f-small"
              color="f-blue"
              onClick={() => {
                pushEventDataLayer(
                  'Interacciones - Top jugadoras',
                  'cur-v-shooter',
                  'click inicio sesion',
                  'inicia sesion'
                )
                dispatch({
                  type: 'set',
                  payload: {
                    modalActive: {
                      type: 'login',
                      props: {
                        close: () => {
                          navigate('/')
                          dispatch({
                            type: 'set',
                            payload: {
                              modalActive: null,
                            },
                          })
                        },
                        handleSuccess: () => {
                          window.location.reload()
                        },
                        mobile: isMobile,
                      },
                    },
                  },
                })
              }}
            />
          </>
        )}
      </section>
    </div>
  )
}

export default TopSection
